import { AxiosMethods } from '@setvi/shared/enums';
import { axiosHelper } from '@setvi/shared/services';

/** Every PDV route lives on revops-api; this keeps that in one place. */
export const pdvCall = <T>(
  endpoint: string,
  method: AxiosMethods = AxiosMethods.GET,
  opts: Record<string, unknown> = {}
): Promise<T> =>
  axiosHelper({
    endpoint,
    method,
    baseURL: process.env.REVOPS_API,
    ...opts
  }) as Promise<T>;

/** One page of every PDV list. */
export const PDV_PAGE_SIZE = 50;

/**
 * Offset of the next page from what is already loaded, or undefined once the list is
 * complete. Shared by every infinite PDV list (they all answer `{ data, total }`).
 */
export const pdvNextOffset = <P extends { data: unknown[]; total: number }>(
  last: P,
  pages: P[]
) => {
  const loaded = pages.reduce((n, p) => n + p.data.length, 0);
  return loaded < last.total && last.data.length > 0 ? loaded : undefined;
};
